<template>
  <footer class="site-footer">
    <div class="container footer-top">
      <div class="footer-brand">
        <SiteLogo dark />
        <p class="footer-desc">
          叮通科技有限公司（厦门）专注于企业数字化转型，核心产品「叮通工作手机」以考勤审批、员工定位、轨迹回放与沟通留痕为基础能力，「叮通ERP
          系统」则帮助企业打通采购、销售、库存、生产与财务全链路管理。
        </p>
        <p class="footer-tag">企业软硬一体的数字化管理伙伴</p>
      </div>

      <div class="footer-col">
        <h4>网站导航</h4>
        <ul>
          <li>
            <router-link to="/">首页</router-link>
          </li>
          <li>
            <router-link to="/product">产品中心</router-link>
          </li>
          <li>
            <router-link to="/about">关于我们</router-link>
          </li>
          <li>
            <router-link to="/contact">联系我们</router-link>
          </li>
        </ul>
      </div>

      <div class="footer-col">
        <h4>产品中心</h4>
        <ul>
          <li>
            <router-link to="/product#work-phone">叮通工作手机</router-link>
          </li>
          <li>
            <router-link to="/product#erp">叮通ERP系统</router-link>
          </li>
          <li>
            <router-link to="/product#phone-features">购机即含功能</router-link>
          </li>
          <li>
            <router-link to="/product">产品方案对比</router-link>
          </li>
        </ul>
      </div>

      <div class="footer-col footer-contact">
        <h4>联系我们</h4>
        <ul>
          <li>
            <a href="tel:13906000035">手机：139 0600 0035</a>
          </li>
          <li>办公地址：厦门市集美区杏林北二路146号501室之二</li>
        </ul>
      </div>

      <div class="footer-col footer-qrcode">
        <h4>扫码联系客服</h4>
        <div class="qrcode-card">
          <img :src="qrcodeImg" alt="微信二维码 - 叮通科技客服" class="qrcode-img" />
          <!-- <p class="qrcode-text">长按识别二维码<br />添加专属客服</p> -->
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <p>© 2023-2026 叮通科技有限公司 版权所有</p>
        <p class="muted-line">让制造更简单 · 让管理更智慧</p>
      </div>
    </div>
  </footer>
</template>

<script>
import SiteLogo from "./SiteLogo.vue";
import qrcodeImg from "@/assets/wechat-qrcode.jpg";

export default {
  name: "SiteFooter",
  components: { SiteLogo },
  data() {
    return {
      qrcodeImg,
    };
  },
};
</script>

<style scoped>
.site-footer {
  background: linear-gradient(160deg, #081736 0%, #0a2f8a 120%);
  color: rgba(255, 255, 255, 0.8);
}
.footer-top {
  display: grid;
  grid-template-columns: 2.2fr 1fr 1fr 1.4fr 1.2fr;
  gap: 44px;
  padding: 64px 24px 48px;
}
.footer-desc {
  margin-top: 18px;
  font-size: 14px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.66);
  max-width: 420px;
}
.footer-tag {
  display: inline-block;
  margin-top: 6px;
  padding: 5px 12px;
  font-size: 12px;
  color: #9fd8ff;
  background: rgba(18, 194, 242, 0.12);
  border-radius: 999px;
}
.footer-col h4 {
  color: #fff;
  font-size: 15px;
  margin-bottom: 18px;
  letter-spacing: 0.06em;
}
.footer-col ul li {
  font-size: 14px;
  line-height: 2.4;
}
.footer-col a {
  color: rgba(255, 255, 255, 0.75);
  transition: color 0.2s ease;
}
.footer-col a:hover {
  color: #4fd2ff;
}
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 18px;
  padding-bottom: 18px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}
.muted-line {
  letter-spacing: 0.2em;
}
.footer-bottom p {
  margin: 0;
}
.qrcode-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px;
  background: #ffffff;
  border-radius: 10px;
  width: fit-content;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
}
.qrcode-img {
  width: 96px;
  height: 96px;
  display: block;
  border-radius: 6px;
}
.qrcode-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #1a2b4d;
  font-weight: 500;
}

@media (max-width: 900px) {
  .footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    padding: 48px 24px 36px;
  }
  .footer-brand {
    grid-column: 1 / -1;
  }
  .footer-qrcode {
    grid-column: 1 / -1;
  }
  .qrcode-card {
    margin: 0 auto;
  }
}
@media (max-width: 520px) {
  .footer-top {
    grid-template-columns: 1fr;
  }
  .footer-bottom-inner {
    justify-content: center;
    text-align: center;
  }
}
</style>
